import { FocusGroupsService } from '@inference.engine/persona-api-client/web';
import { personasHttp } from '@/lib/api/personas-client';
import { i18n } from '@/shared/i18n';
import type { FocusGroupTableData } from '../types';

export async function deleteFocusGroup(id: string): Promise<void> {
  await FocusGroupsService.delete({
    client: personasHttp,
    path: { id },
    throwOnError: true,
  });
}

export async function listFocusGroups(): Promise<{ data: FocusGroupTableData[]; total: number }> {
  const response = await FocusGroupsService.list({
    client: personasHttp,
    query: { take: 200 },
  });
  const body = response.data;

  if (!body) return { data: [], total: 0 };

  return {
    data: body.data.map((item) => ({
      id: item.id,
      title: item.title ?? i18n.t('audiences:focusGroups.focusGroupsContent.untitled'),
      status: item.status,
      personaCount: item.personaCount,
      createdBy: item.createdBy,
      // `owner` is typed as required, but an older backend (deploy/rollout window)
      // may omit it — guard so the list never crashes on a missing field.
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      owner: item.owner ?? {
        id: item.createdBy,
        name: i18n.t('common:components.sidePanel.unknown'),
        avatarUrl: null,
      },
      createdAt: item.createdAt,
      completedAt: item.completedAt ?? null,
    })),
    total: body.total,
  };
}
